module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e0dc36f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/muse-ui/src/table/tbody.vue
// module id = 424
// module chunks = 1